/*
  The ambassador purchase modal (snippets/ambassador-modal.liquid).

  Open/close, focus trap and Escape follow ticket-modal.js.

  Signed out, the submit saves the tier and nickname (PENDING_KEY) and goes to
  Shopify's email-code login with return_to = this page + ?ambassador_modal=N.
  Back on the site, signed in, the sheet reopens on that tier with the
  nickname filled — from the URL, or from what was saved if the login landed
  elsewhere. Signed in, the submit is the part that matters:

    1. read /cart.js and set every ambassador SUBSCRIPTION line to 0 — a tier
       picked earlier, or one restored by Back from checkout (the bug of
       22.10: «Масштабую» and «Підтримую» in one checkout, 125 zł). One-time
       gifts to Galas, the same product without a plan, stay;
    2. add the chosen tier with the monthly plan, quantity 1, the account
       (`_ambassador_email`, signed `_ambassador_customer`) and the Telegram
       nickname if one was given;
    3. go to checkout.

  window.GalasAmbassador.open({ tier }) is how the donate and join modals hand
  over to it.
*/
(function () {
  if (window.GalasAmbassador) return;

  var modalEl = document.querySelector('[data-ambassador-modal]');
  if (!modalEl) return;

  var panelEl = modalEl.querySelector('[data-ambassador-panel]');
  var formEl = modalEl.querySelector('[data-ambassador-form]');
  var tiersEl = modalEl.querySelector('[data-ambassador-tiers]');
  var perksEl = modalEl.querySelector('[data-ambassador-perks]');
  var tgEl = modalEl.querySelector('[data-amb-telegram]');
  var errorEl = modalEl.querySelector('[data-ambassador-error]');
  var lineEl = modalEl.querySelector('[data-ambassador-line]');
  var ctaEl = modalEl.querySelector('[data-ambassador-cta]');
  var submitEl = modalEl.querySelector('[data-ambassador-submit]');

  var PLAN = Number(modalEl.getAttribute('data-plan'));
  var PRODUCT = Number(modalEl.getAttribute('data-product-id'));
  var CURRENCY = modalEl.getAttribute('data-currency') || 'zł';
  var PER_MONTH = modalEl.getAttribute('data-per-month') || '';
  var SIGNED_IN = modalEl.getAttribute('data-signed-in') === 'true';
  var MEMBER = modalEl.hasAttribute('data-member');
  var PENDING_KEY = 'galas:ambassador-pending';
  var PENDING_TTL = 2 * 60 * 60 * 1000;
  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var state = { open: false, opener: null, submitting: false };

  function root() { return ((window.Shopify || {}).routes || {}).root || '/'; }
  function fill(template, values) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return values[k] == null ? '' : values[k]; });
  }
  function tiers() { return Array.prototype.slice.call(tiersEl.querySelectorAll('[data-tier]')); }
  function active() { return tiers().filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers()[0]; }

  /* ── tier ─────────────────────────────────────────────────────────────── */
  function select(tier) {
    tiers().forEach(function (t) {
      var on = t === tier;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var amount = tier.getAttribute('data-amount');
    var price = amount + ' ' + CURRENCY;
    var list = modalEl.querySelector('[data-ambassador-list="' + tier.getAttribute('data-tier') + '"]');
    perksEl.innerHTML = list ? list.innerHTML : '';
    lineEl.textContent = fill(modalEl.getAttribute('data-line'), { price: price });
    if (ctaEl && SIGNED_IN) ctaEl.textContent = fill(modalEl.getAttribute('data-cta'), { price: price + PER_MONTH });
  }

  tiersEl.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-tier]');
    if (tier) select(tier);
  });
  tiersEl.addEventListener('keydown', function (e) {
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!keys[e.key]) return;
    e.preventDefault();
    var list = tiers();
    var next = list[(list.indexOf(active()) + keys[e.key] + list.length) % list.length];
    select(next);
    next.focus({ preventScroll: true });
  });

  /* ── open / close ─────────────────────────────────────────────────────── */
  function open(options) {
    options = options || {};
    var wanted = options.tier && tiers().filter(function (t) { return t.getAttribute('data-tier') === String(options.tier); })[0];
    select(wanted || active());
    clearError();
    setSubmitting(false);
    if (state.open) return;
    state.open = true;
    state.opener = options.opener || document.activeElement;
    modalEl.hidden = false;
    requestAnimationFrame(function () {
      modalEl.classList.add('is-open');
      modalEl.setAttribute('aria-hidden', 'false');
    });
    document.documentElement.classList.add('is-ticket-modal-open');
    document.body.classList.add('is-ticket-modal-open');
    document.addEventListener('keydown', onKeydown, true);
    var first = active();
    if (first) first.focus({ preventScroll: true });
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    if (SIGNED_IN) dropPending();
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-ticket-modal-open');
    document.body.classList.remove('is-ticket-modal-open');
    document.removeEventListener('keydown', onKeydown, true);
    setTimeout(function () { if (!state.open) modalEl.hidden = true; }, 320);
    if (state.opener && typeof state.opener.focus === 'function') state.opener.focus({ preventScroll: true });
    state.opener = null;
  }

  function focusable() {
    return Array.prototype.filter.call(panelEl.querySelectorAll(FOCUSABLE), function (el) {
      return !el.disabled && el.offsetParent !== null && el.tabIndex !== -1;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusable();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var current = document.activeElement;
    if (e.shiftKey && (current === first || !panelEl.contains(current))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (current === last || !panelEl.contains(current))) { e.preventDefault(); first.focus(); }
  }

  modalEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-ambassador-close]')) close();
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-ambassador-open]');
    if (!trigger) return;
    e.preventDefault();
    open({ tier: trigger.getAttribute('data-ambassador-tier'), opener: trigger });
  });

  /* ── errors ───────────────────────────────────────────────────────────── */
  function showError(message, field) {
    errorEl.textContent = message;
    errorEl.hidden = false;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
  }
  function clearError() {
    errorEl.hidden = true;
    errorEl.textContent = '';
    if (tgEl) tgEl.removeAttribute('aria-invalid');
  }
  function setSubmitting(on) {
    state.submitting = on;
    if (!submitEl) return;
    submitEl.disabled = on;
    submitEl.classList.toggle('is-loading', on);
  }
  if (tgEl) tgEl.addEventListener('input', clearError);

  /* ── submit ───────────────────────────────────────────────────────────── */
  function json(url, body) {
    return fetch(root() + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' ' + res.status);
      return res.json();
    });
  }

  function clearAmbassadorLines() {
    return json('cart.js').then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        var isTier = item.product_id === PRODUCT && (item.selling_plan_allocation || (item.properties || {})._ambassador);
        if (isTier) updates[item.key] = 0;
      });
      return Object.keys(updates).length ? json('cart/update.js', { updates: updates }) : cart;
    });
  }

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.submitting || MEMBER) return;
    clearError();

    var tier = active();
    var tg = window.GalasTelegram ? window.GalasTelegram.read(tgEl) : { ok: true, value: tgEl.value.trim() };
    if (!tg.ok) return showError(tgEl.getAttribute('data-error'), tgEl);

    if (!SIGNED_IN) return signIn(tier.getAttribute('data-tier'), tg.value);

    var properties = { _ambassador: tier.getAttribute('data-tier') };
    var email = modalEl.getAttribute('data-email');
    var lineCustomer = modalEl.getAttribute('data-line-customer');
    if (email) properties._ambassador_email = email;
    if (lineCustomer) properties._ambassador_customer = lineCustomer;
    if (tg.value) properties.Telegram = tg.value;

    setSubmitting(true);
    clearAmbassadorLines()
      .then(function () {
        return json('cart/add.js', { items: [{ id: Number(tier.getAttribute('data-variant')), quantity: 1, selling_plan: PLAN, properties: properties }] });
      })
      .then(function () {
        dropPending();
        window.location.href = root() + 'checkout';
      })
      .catch(function () {
        setSubmitting(false);
        showError(modalEl.getAttribute('data-error-generic'));
      });
  });

  // Back from checkout (bfcache): the button works again.
  window.addEventListener('pageshow', function () { setSubmitting(false); });

  /* ── sign-in round trip ────────────────────────────────────────────────── */
  function storage(fn) { try { return fn(window.localStorage); } catch (e) { return null; } }

  function signIn(tier, telegram) {
    storage(function (ls) { ls.setItem(PENDING_KEY, JSON.stringify({ tier: tier, telegram: telegram, at: Date.now() })); });
    var back = new URL(window.location.href);
    back.searchParams.set('ambassador_modal', tier);
    back.hash = '';
    setSubmitting(true);
    window.location.href = modalEl.getAttribute('data-login-url') + encodeURIComponent(back.pathname + back.search);
  }

  // Read, not consumed: a login can land through more than one page load (a
  // redirect, the preview bar's reload), and the first must not use it up.
  // Cleared when the sheet is closed or the buyer goes to checkout.
  function takePending() {
    var saved = storage(function (ls) { var raw = ls.getItem(PENDING_KEY); return raw && JSON.parse(raw); });
    return saved && Date.now() - saved.at < PENDING_TTL ? saved : null;
  }
  function dropPending() { storage(function (ls) { ls.removeItem(PENDING_KEY); }); }

  // ?ambassador_modal=2 opens on that tier; a sign-in that came back (here or
  // anywhere else on the site) reopens the sheet the buyer left.
  var url = new URL(window.location.href);
  var param = url.searchParams.get('ambassador_modal');
  var pending = SIGNED_IN ? takePending() : null;
  if (param !== null || pending) {
    if (pending && pending.telegram && tgEl && !tgEl.value) tgEl.value = pending.telegram;
    open({ tier: param !== null ? param : pending.tier });
    if (param !== null && SIGNED_IN) {
      // Drop the parameter, so a reload or a shared link does not reopen the sheet.
      url.searchParams.delete('ambassador_modal');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
  }

  select(active());
  window.GalasAmbassador = { open: open, close: close, clearAmbassadorLines: clearAmbassadorLines };
})();
